import { Component, Inject, OnInit, Optional, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from 'src/app/api.service';


@Component({
  selector: 'app-create-company-dialog',
  templateUrl: './create-company-dialog.component.html',
  styleUrls: ['./create-company-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateCompanyDialogComponent implements OnInit {

  name;
  country;
  countryCode;
  branchCode;
  distinctUser;
  hide = true;
  companyData: {name:'',country:'',country_code:'', branch_code:'',id:'',distinct:false, secret:'',sid:''};
  newCompanyData = new FormGroup({
    companyName: new FormControl('', Validators.required),
    country: new FormControl('', Validators.required),
    countryCode: new FormControl('', Validators.required),
    branchCode: new FormControl('', Validators.required),
    distinctUser:new FormControl(''),
    secret:new FormControl(''),
    sid:new FormControl('')
  })
  constructor(
    public dialogRef: MatDialogRef<CreateCompanyDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar
  ) {
    
    this.companyData = data.companyData;
    // this.name = this.companyData.name;
    // this.country = this.companyData.country;
    // this.countryCode = this.companyData.country_code;
    // this.branchCode = this.companyData.branch_code;
    // this.distinctUser = this.companyData.distinct;
  }
 
  ngOnInit(): void {
    this.newCompanyData.controls['companyName'].setValue(this.companyData.name);
    this.newCompanyData.controls['country'].setValue(this.companyData.country);
    this.newCompanyData.controls['countryCode'].setValue(this.companyData.country_code);
    this.newCompanyData.controls['branchCode'].setValue(this.companyData.branch_code);
    this.newCompanyData.controls['secret'].setValue(this.companyData.secret);
    this.newCompanyData.controls['sid'].setValue(this.companyData.sid);
    this.newCompanyData.controls['distinctUser'].setValue(this.companyData.distinct);
  }

  close(): void {
    this.dialogRef.close();
  }

  save(){
     
    if (this.newCompanyData.valid) {
      const companyInfo = {
        ...this.newCompanyData.value,
      }
      if(this.companyData.id){
        let createCompanyInfo = {
          name: this.newCompanyData.get('companyName').value,
          country: this.newCompanyData.get('country').value,
          country_code: this.newCompanyData.get('countryCode').value,
          branch_code: this.newCompanyData.get('branchCode').value,
          id: this.companyData.id,
          secret:this.newCompanyData.get('secret').value,
          sid:this.newCompanyData.get('sid').value,
          distinct: this.newCompanyData.get('distinctUser').value
        }
        console.log(this.companyData)
        this._apiService.updateCompany(createCompanyInfo).subscribe(res => {
          if (res) {
            console.log(res);
          }
        },
        (error)=>{
          console.log(error);
        });
      }else{
        let createCompanyInfo = {
          name: this.newCompanyData.get('companyName').value,
          country: this.newCompanyData.get('country').value,
          country_code: this.newCompanyData.get('countryCode').value,
          branch_code: this.newCompanyData.get('branchCode').value,
          secret:this.newCompanyData.get('secret').value,
          sid:this.newCompanyData.get('sid').value,
          distinct: this.newCompanyData.get('distinctUser').value
        }
        this._apiService.createNewCompany(createCompanyInfo).subscribe(res => {
          if (res) {
            console.log(res);
          }
        },
        (error)=>{
          console.log(error);
        });
      }
      this.dialogRef.close();
    }
  }
}